import {ResourceTaskTime} from "./ResourceTaskTime";
import {AppFile} from "./AppFile";
import {TaskActivity} from './TaskActivity';

export enum Priorities {
  Normal = 0,
  Critical = 1
}

export enum Statuses {
  Released = 1,
  Planned = 2,
  Active = 3,
  NotCompleted = 4,
  Completed = 5,
}

export class Task {
  Task_GUID?: string;
  No?: string;
  Title?: string;
  Task_Type?: string;
  Maintenance_Type?: string;
  Maintenance_Template_No?: number;
  Anlæg?: string;
  Anlægsbeskrivelse?: string;
  Text?: string;
  Weekly?: boolean;
  Daily?: boolean;
  Status?: string;
  Latitude?: number;
  Longitude?: number;
  Planned_Date?: string;
  Responsible?: string;
  Responsible_Name?:string;
  OTS_Responsible?: string;
  OTS_Responsible_Name?: string;
  Customer_No?: string;
  Customer_Name?: string;
  JobNo?: string;
  Job_Task_No?: string;
  Priority?: string;
  start?: string;
  end?: string;
  allDay?: boolean;
  color?: string;
  editable?: boolean;
  resources?: string[];
  ColorCode?: string;
  ResourceTaskTimes?: ResourceTaskTime[];
  fileBlobs?: AppFile[];
  points? = 10;
  Created_By?: string;
  Created_DateTime?: string;
  Create_Job?: boolean;
  Job_Description?: string;
  Job_Task_Description?: string;
  Estimate?: number;
  Work_Description?: string;
  Estimated_Hours?: string;
  Planned_Hours?: string;
  To_Be_Done_By?: string;
  Realised_Time?: string;
  Deadline?: string;
  Invoiceable?: boolean;
  Desciption?: string;
  App_Task_Category?: string;
  App_Task_Category_Description?: string;
  Maintenance_Object?: string;
  App_Notes?: string;
  Project_Manager?: string;
  Has_App_File? : string;
  Completed_By?: string;
  Completed_By_Stamp?: string;
  TaskActivities?: TaskActivity[];
  Extended_Description?: string;
  Shortcut_Dimension_2_Code?: string;
  Shortcut_Dimension_2_Name?: string;
  Completed_Date_Time?: Date;
  Company_Reference?: string;
  Task_Level?: TaskLevel;
  Company_Type?: string;
}

export enum TaskLevel {
  Intern = 'Intern',
  OTS = 'OTS'
}

export enum ModalType {
  CreateNotificationModal = 'CreateNotificationModal',
  DetailNotificationModal = 'DetailNotificationModal',
  DetailTaskModal = 'DetailTaskModal'
}










// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/Task.ts